import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SamaScrollSectionNavigationModule } from '@sama/ui-library';
import { VideoContentModule } from '../../../2d/video-content/video-content.module';
import { PointCloudContentModule } from '../../../3d/point-cloud-content.module';
import { MlAssistComponent } from '../../../core/outputs/annotation/annotation-shared/toolbars/ml-assist/ml-assist.component';
import { VideoHelpModalComponent } from '../../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/video-help-modal.component';
import { Enable3DShortcutsToggleComponent } from '../../../core/outputs/annotation/video/enable-3d-shortcuts-toggle/enable-3d-shortcuts-toggle.component';
import { SharedModule } from '../../../shared/shared.module';
import { AnnotationSharedModule } from '../annotation-shared/annotation-shared.module';
import { VideoLayoutComponent } from './video-layout.component';
import { VideoOutputComponent } from './video-output.component';

@NgModule({
  imports: [
    AnnotationSharedModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    PointCloudContentModule,
    SamaScrollSectionNavigationModule,
    SharedModule,
    VideoContentModule,
  ],
  declarations: [
    Enable3DShortcutsToggleComponent,
    VideoHelpModalComponent,
    VideoLayoutComponent,
    VideoOutputComponent,
    MlAssistComponent,
  ],
  exports: [VideoOutputComponent],
})
export class VideoModule {}
